<template>
  <GridContainer>
    <div class="col-span-12 mb-20">
      <slot />
    </div>
  </GridContainer>
</template>

<script setup lang="ts">
import GridContainer from 'src/components/common/GridContainer.vue';
</script>
